import React from 'react';
import { IconLoader } from 'common/IconLoader';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import '../../FiltersBar.css';

const FiltersBarUpdateIcon = (props) => {
  return props.canFilterSetUpdate() ? (
    <div className="FiltersBar_UpdateIcon" onClick={props.onUpdateFilterSet}>
      <SvgAF img={IconLoader.bttn_update_filterset_on} hover={IconLoader.bttn_update_filterset_hover} />
    </div>
  ) : (
    <div className="FiltersBar_UpdateIcon">
      <SvgAF img={IconLoader.bttn_update_filterset_off} hover={IconLoader.bttn_update_filterset_off} />
    </div>
  );
};

export default FiltersBarUpdateIcon;
